import axios from 'axios';
import { ITEM_TYPE, PATH, DIACRITIC_MAP } from '../constants';

// todo - solve external loading
import mainData from '../data/toto-100-leti.json';
import infoData from '../data/info.json';
import homepage from '../data/homepage.json';

// ---------------------------------------------------
// Hash
// ---------------------------------------------------

let hashInited = false;
let hash = '';

const fetchHash = () => {
  axios
    .get(window.location.href.indexOf('specialy') === -1
      ? '/player'
      : '/specialy/totostoleti/player')
    .then((response) => {
      hash = response.data.split('vApp')[1].split('"')[1];
      // repeat in given interval
      setTimeout(() => {
        fetchHash();
      }, 1000 * 60 * 30);
    })
    .catch((error) => {
      console.log(error);
      // todo - solve error state
      hash = '2ff0e916016e248d7ea926fec199595af7b4b545';
    });
};

export const initHash = () => {
  if (window.hash) {
    hash = window.hash;
  }
  // todo - review implementation
  if (!hashInited) {
    hashInited = true;
    fetchHash();
  }
};

// todo - review implementation
export const getHash = () => hash;

// ---------------------------------------------------
// Video images
// ---------------------------------------------------

// todo - review implementation

export const videoImageUrl = (videoData) => {
  // bonus
  if (videoData.bonus && videoData.bonus.length > 0) {
    return `//decko.ceskatelevize.cz/cms/ct-src/video/b${encodeURIComponent(videoData.bonus)}/uni.jpg`;
  }
  const cleanedIdec = videoData.idec.replace(/\s/g, '').replace(/\//g, '');
  // image url - from xml api - now for 've-vysilani'
  // todo maybe implement even for normal videos -
  // when/if info and main data will be merged by export
  if (videoData.imageURL) {
    return videoData.imageURL.replace('140', '512');
  }
  // index
  if (videoData.index && videoData.index.length > 0) {
    return `//img.ceskatelevize.cz/ivysilani/indexes/photos/w512/${cleanedIdec.substring(
      0,
      3,
    )}/${cleanedIdec}/${videoData.index}.jpg`;
  }
  // sidp
  if (videoData.sidp && videoData.sidp.length > 0) {
    return `//imgct.ceskatelevize.cz/cache/w512/upload/program/porady/${
      videoData.sidp
    }/foto/uni_${cleanedIdec}.jpg`;
  }
  // default
  return '';
};

// ---------------------------------------------------
// Video source
// ---------------------------------------------------

export const getVideoSource = (videoData) => {
  if (videoData.bonus && videoData.bonus.length > 0) {
    return `${
      PATH.FRAME
    }/?hash=${getHash()}&bonus=${
      videoData.bonus
    }&origin=noads&autoStart=true`;
  }
  if (videoData.index && videoData.index.length > 0) {
    return `${
      PATH.FRAME
    }/?hash=${getHash()}&IDEC=${
      videoData.idec
    }&index=${videoData.index}&origin=noads&autoStart=true`;
  }
  // todo - revise - now for 've-vysilani' - shouldn't be idec replace/parsing be added to all cases?
  return `${
    PATH.FRAME
  }/?hash=${getHash()}&IDEC=${videoData.idec.replace(
    '%2F',
    '',
  )}&origin=noads&autoStart=true`;
};

// ---------------------------------------------------
// Main data
// ---------------------------------------------------

const tagList = [];
const mapMarkersData = [];
const markersPositions = []; // for parsing

// note - all implementations are temporary
// and should be updated once external data fetch is implemented

export const getCategoryData = categoryId =>
  Object.entries(mainData).filter(item => String(item[1].category) === categoryId);

export const getTagData = tag =>
  Object.entries(mainData).filter(item => item[1].tags.indexOf(tag) !== -1);

export const getItemData = itemId =>
  new Promise((resolve, reject) => {
    if (itemId.indexOf(ITEM_TYPE.VYSILANI) === 0) {
      getVysilaniData()
        .then((data) => {
          resolve(data.data[itemId]);
        })
        .catch(() => {
          // todo - solve error state
          reject();
        });
    } else {
      resolve(mainData[itemId]);
    }
  });

export const getVideoData = () =>
  Object.entries(mainData).filter(item => item[1].type === ITEM_TYPE.VIDEO && item[1].idec.length > 0);

export const getTagList = () =>
  new Promise((resolve) => {
    // todo - raw implementation
    if (tagList.length === 0) {
      // set list
      Object.entries(mainData).forEach((item) => {
        item[1].tags.forEach((tag) => {
          if (!tagList.includes(tag)) {
            tagList.push(tag);
          }
        });
      });
    }
    tagList.sort((a, b) => a.localeCompare(b));
    resolve(tagList);
  });

const checkMarkerPosition = (item) => {
  // todo - maybe do during parsing and not on user side
  const newItem = [...item];
  let gpsn = Number(newItem[1].gpsn);
  let gpse = Number(newItem[1].gpse);
  let gpsString = `${gpsn}-${gpse}`;

  while (markersPositions.includes(gpsString)) {
    gpsn += 0.0005;
    gpse += 0.0005;
    gpsString = `${gpsn}-${gpse}`;
  }
  markersPositions.push(gpsString);
  newItem[1].gpsn = gpsn;
  newItem[1].gpse = gpse;
  return newItem;
};

export const getMapMarkersData = () =>
  new Promise((resolve) => {
    // todo - raw implementation
    if (mapMarkersData.length === 0) {
      // set list
      Object.entries(mainData).forEach((item) => {
        if (item[1].gpsn.length > 0 && item[1].gpse.length > 0) {
          mapMarkersData.push(checkMarkerPosition(item));
        }
      });
    }
    resolve(mapMarkersData);
  });

// ---------------------------------------------------
// Diacritic replace
// ---------------------------------------------------

let diacriticsMapInited = false;
const diacriticsMap = {};

export const initDiacriticMap = () => {
  if (!diacriticsMapInited) {
    diacriticsMapInited = true;
    for (let i = 0; i < DIACRITIC_MAP.length; i += 1) {
      const { letters } = DIACRITIC_MAP[i];
      for (let j = 0; j < letters.length; j += 1) {
        diacriticsMap[letters[j]] = DIACRITIC_MAP[i].base;
      }
    }
  }
};

export const replaceDiacritic = (value) => {
  initDiacriticMap(); // note - not ideal - maybe call right after app init
  return value.replace(/[^\u0000-\u007E]/g, a => diacriticsMap[a] || a);
};

// ---------------------------------------------------
// Main data - Search
// ---------------------------------------------------

export const search = (term) => {
  const parsedTerm = replaceDiacritic(term.toUpperCase());
  const result = [];
  const match = [];

  // get matches
  Object.entries(mainData).forEach((item) => {
    const pos = replaceDiacritic(item[1].title.toUpperCase()).indexOf(parsedTerm);
    if (pos !== -1) {
      match.push({
        pos,
        item,
      });
    }
  });

  // sort
  match.sort((x, y) => x.pos - y.pos);

  // get first
  for (let i = 0; i < Math.min(match.length, 10); i += 1) {
    result.push(match[i].item);
  }

  return result;
};

// ---------------------------------------------------
// Info data
// ---------------------------------------------------

// note - temporary - should be updated once external data fetch is implemented

export const getInfo = (videoId) => {
  if (infoData[videoId]) {
    return infoData[videoId];
  }
  return {};
};

// ---------------------------------------------------
// Homepage data
// ---------------------------------------------------

// todo - add some week auto-change algorithm
const homeLineData = {};
let homeTopicLineData = null;

export const getHomeLineData = (categoryId) => {
  if (!homeLineData[categoryId]) {
    let lineData = [];
    const videos = [];
    const articles = [];
    const categoryData = getCategoryData(categoryId.toString());

    // todo - probably seed-randomise before picking - use week 'id' as seed
    // todo - temp solution - add some 'seed' based
    for (let i = 0; i < categoryData.length; i += 1) {
      const data = categoryData[i];
      if (
        data[1].type === ITEM_TYPE.VIDEO ||
        data[1].type === ITEM_TYPE.MEMORY
      ) {
        videos.push(data);
      } else if (data[1].type === ITEM_TYPE.ARTICLE) {
        articles.push(data);
      }
      // check end
      if (videos.length >= 8 && articles.length >= 2) {
        break;
      }
    }

    // concat
    lineData = videos.splice(0, 8).concat(articles.splice(0, 2));

    // randomise order
    // todo - temp solution
    lineData.sort((x, y) => {
      const a = x[1].title;
      const b = y[1].title;
      if (a < b) {
        return -1;
      }
      if (a > b) {
        return 1;
      }
      return 0;
    });

    // done
    homeLineData[categoryId] = lineData;
  }
  return homeLineData[categoryId];
};

// todo - needs to be reworked as promise when all data loading will be from external sources
export const getHomeTopicLineData = (date) => {
  if (!homeTopicLineData) {
    let topicId = 0;
    for (let d = 0; d < homepage.data.length; d += 1) {
      const currentYear = new Date().getFullYear();
      const testDate = new Date(`${currentYear}-${homepage.data[d].date}T00:00:00.000+01:00`);
      if (testDate <= date) {
        topicId = d;
      }
    }

    const topicData = homepage.data[topicId];
    const lineData = [];
    for (let i = 0; i < topicData.lineData.length; i += 1) {
      const itemId = topicData.lineData[i];
      lineData.push([itemId, mainData[itemId]]);
    }
    topicData.lineData = lineData;
    homeTopicLineData = topicData;
  }
  return homeTopicLineData;
};

// ---------------------------------------------------
// Homepage program data
// ---------------------------------------------------

let programTips = null;

export const getHomeProgramLineData = () =>
  new Promise((resolve, reject) => {
    if (programTips) {
      // already loaded
      resolve(programTips);
    } else {
      // load
      axios
        .get('//stoleti.strangevillage.com/data/tips-week.json')
        .then((response) => {
          if (response.data) {
            programTips = response.data.tips;
            resolve(programTips);
          } else {
            reject();
          }
        })
        .catch((error) => {
          reject(error);
        });
    }
  });

// ---------------------------------------------------
// iOS
// ---------------------------------------------------

// todo - temp solution

export const isIOs = () => /iPad|iPhone|iPod/.test(navigator.platform);

// ---------------------------------------------------
// Ve Vysilani
// ---------------------------------------------------

let veVysilaniData = null; // for details
let veVysilaniArray = null; // for list

export const getVysilaniObject = () => ({
  data: veVysilaniData,
  array: veVysilaniArray,
});

export const getVysilaniData = () =>
  new Promise((resolve, reject) => {
    if (veVysilaniData) {
      resolve(getVysilaniObject());
    } else {
      axios
        .get('//stoleti.strangevillage.com/data/vysilani.json')
        .then((response) => {
          if (response.data) {
            veVysilaniData = response.data;
            veVysilaniArray = Object.entries(veVysilaniData);
            resolve(getVysilaniObject());
          } else {
            reject();
          }
        })
        .catch((error) => {
          reject(error);
        });
    }
  });

// ---------------------------------------------------
// School
// ---------------------------------------------------

let schoolList = null;
const schoolSheetsPool = {};

export const getSchoolList = () =>
  new Promise((resolve, reject) => {
    if (schoolList) {
      resolve(schoolList);
    } else {
      axios
        .get(`${PATH.SCHOOL}list.json`)
        .then((response) => {
          if (response.data && response.data.sheets) {
            schoolList = response.data.sheets;
            resolve(schoolList);
          } else {
            reject();
          }
        })
        .catch((error) => {
          reject(error);
        });
    }
  });

export const getSchoolSheet = sheetId =>
  new Promise((resolve, reject) => {
    if (schoolSheetsPool[sheetId]) {
      resolve(schoolSheetsPool[sheetId]);
    } else {
      axios
        .get(`${PATH.SCHOOL}sheets/${sheetId}.json`)
        .then((response) => {
          if (response.data) {
            schoolSheetsPool[sheetId] = response.data;
            resolve(schoolSheetsPool[sheetId]);
          } else {
            reject();
          }
        })
        .catch((error) => {
          reject(error);
        });
    }
  });

// ---------------------------------------------------
// Maps
// ---------------------------------------------------

// todo - temp qick implementation - revise + maybe move somewhere else

const checkMarker = (category, itemData) =>
  // todo maybe even filter by main category first
  itemData.gpsn.length > 0 &&
  itemData.gpse.length > 0 &&
  itemData.category === category;

export const getMapMarkers = category =>
  Object.entries(mainData).filter(item => checkMarker(category, item[1]));



// WEBPACK FOOTER //
// ./src/api/index.js